import { render, staticRenderFns } from "./myOrderPage.vue?vue&type=template&id=ed43e8d2&scoped=true&"
import script from "./myOrderPage.vue?vue&type=script&lang=ts&"
export * from "./myOrderPage.vue?vue&type=script&lang=ts&"
import style0 from "./myOrderPage.vue?vue&type=style&index=0&id=ed43e8d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../wellness/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed43e8d2",
  null
  
)

export default component.exports